const RadiusFoundationsThemes = {
    radius_comp_resources_virtualkeyboard_borderradius: '0.75rem',
    radius_comp_forms_checkbox_radiussize: '0.25rem',
    radius_comp_forms_chip_radiussize: '0.5rem',
    radius_comp_forms_toggle_thumbradiussize: '22.5rem',
    radius_comp_forms_pill_radiussize: '22.5rem',
    radius_comp_forms_toggle_radiussize: '22.5rem',
    radius_comp_forms_fileuploader_radiussize: '1rem',
    radius_comp_forms_input_radiussize: '0.75rem',
    radius_comp_forms_inputcurrencylarge_radiussize: '1rem',
    radius_comp_forms_inputsignature_radiussize: '1rem',
    radius_comp_forms_inputdigitsequence_radiussize: '0.5rem',
    radius_00: '0rem',
    radius_50: '0.125rem',
    radius_100: '0.25rem',
    radius_125: '0.375rem',
    radius_150: '0.5rem',
    radius_200: '0.75rem',
    radius_250: '1rem',
    radius_275: '1.0625rem',
    radius_285: '1.125rem',
    radius_300: '1.5rem',
    radius_1000: '22.5rem',
    radius_button_small: '1rem',
    radius_button_large: '1.5rem',
    radius_comp_actions_button_radiussizelarge: '1.5rem',
    radius_comp_actions_button_radiussizesmall: '1rem',
};
export { RadiusFoundationsThemes };
//# sourceMappingURL=radius-foundations.themes.js.map